import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/services/guard/auth.guard';
import { ChargeWalletComponent } from './components/charge-wallet/charge-wallet.component';
import { productDetailsComponent } from './components/product-details/product-details.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { PaymentStatusComponent } from './components/payment-status/payment-status.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PaymentComponent } from './components/payment/payment.component';
import { ShopSummaryComponent } from './components/shop-summary/shop-summary.component';
import { WhishListComponent } from './components/whish-list/whish-list.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { ChargeWalletSheetComponent } from './components/charge-wallet-sheet/charge-wallet-sheet.component';
import { ProductDetailUrlGuard } from '../shared/services/guard/product-detail-url.guard';

const routes: Routes = [
  {
    path: 'product/:id/:name',
    component: productDetailsComponent,
    canActivate: [ProductDetailUrlGuard],
  },
  {
    path: 'charge-wallet',
    component: ChargeWalletComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
  },
  {
    path: 'profile/edit',
    component: EditProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'wishlist',
    component: WhishListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'wallet',
    component: WalletComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'wallet/charge',
    component: ChargeWalletSheetComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'payment',
    component: PaymentStatusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'checkout',
    component: PaymentComponent,
  },
  {
    path: 'order-history',
    component: ShopSummaryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductRoutingModule {}
